export const API = {
  Query: {
    Coins: process.env.NEXT_PUBLIC_DOMAIN + "/api/backendQueryCoins",
    UserStats: process.env.NEXT_PUBLIC_DOMAIN + "/api/backendQueryUserStats",
    UserStatsHistory:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/backendQueryUserStatsHistory",
    PoolStats: process.env.NEXT_PUBLIC_DOMAIN + "/api/backendQueryPoolStats",
    PoolStatsHistory:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/backendQueryPoolStatsHistory",
    Payouts: process.env.NEXT_PUBLIC_DOMAIN + "/api/backendQueryPayouts",
    ProfitSwitchCoeff:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/backendQueryProfitSwitchCoeff",
    UpdateProfitSwitchCoeff:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/backendUpdateProfitSwitchCoeff",
    PoolLuck: process.env.NEXT_PUBLIC_DOMAIN + "/api/backendPoolLuck",
    WorkerStatsHistory:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/backendQueryWorkerStatsHistory",
    UserBalance:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/backendQueryUserBalance",
    FoundBlocks:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/backendQueryFoundBlocks",
    PPLNSPayouts:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/backendQueryPPLNSPayouts",
    PPLNSAcc: process.env.NEXT_PUBLIC_DOMAIN + "/api/backendQueryPPLNSAcc",
    PPSPayouts:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/backendQueryPPSPayouts",
    PPSPayoutsAcc:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/backendQueryPPSPayoutsAcc",
    // NEW API: unified pool configuration (PPS + payouts).
    Config:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/backendGetConfig",
    ConfigUpdate:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/backendUpdateConfig",
    PpsState:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/backendGetPPSState",
    PpsHistory:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/backendQueryPPSHistory",
  },
  User: {
    Settings: process.env.NEXT_PUBLIC_DOMAIN + "/api/userGetSettings",
    Credentials: process.env.NEXT_PUBLIC_DOMAIN + "/api/userGetCredentials",
    AllUsers: process.env.NEXT_PUBLIC_DOMAIN + "/api/userEnumerateAll",
    AllFeePlans: process.env.NEXT_PUBLIC_DOMAIN + "/api/userEnumerateFeePlan",
    AllInstances: process.env.NEXT_PUBLIC_DOMAIN + "/api/instanceEnumerateAll",
    UpdateSettings: process.env.NEXT_PUBLIC_DOMAIN + `/api/userUpdateSettings`,
    Activate2faInitiate:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/userActivate2faInitiate",
    Deactivate2faInitiate:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/userDeactivate2faInitiate",
    ChangePasswordForce:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/userChangePasswordForce",
    UpdatePersonalFee:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/userUpdatePersonalFee",
    ChangePassword:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/userChangePasswordInitiate",
    QueryFeePlan: process.env.NEXT_PUBLIC_DOMAIN + "/api/userQueryFeePlan",
    CreateFeePlan: process.env.NEXT_PUBLIC_DOMAIN + "/api/userCreateFeePlan",
    DeleteFeePlan: process.env.NEXT_PUBLIC_DOMAIN + "/api/userDeleteFeePlan",
    RenewFeePlanReferralId:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/userRenewFeePlanReferralId",
    UpdateFeePlan: process.env.NEXT_PUBLIC_DOMAIN + "/api/userUpdateFeePlan",
    ChangeFeePlan: process.env.NEXT_PUBLIC_DOMAIN + "/api/userChangeFeePlan",
    AdjustInstantPayoutThreshold:
      process.env.NEXT_PUBLIC_DOMAIN +
      "/api/userAdjustInstantPayoutThreshold",
    ResendEmail: process.env.NEXT_PUBLIC_DOMAIN + "/api/userResendEmail",
    Action: process.env.NEXT_PUBLIC_DOMAIN + "/api/userAction",
    UpdateCredentials:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/userUpdateCredentials",
    GetFeePlan: process.env.NEXT_PUBLIC_DOMAIN + "/api/userGetFeePlan",
    ForcePayout: process.env.NEXT_PUBLIC_DOMAIN + "/api/backendManualPayout",
    GetWatcherLink:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/userQueryMonitoringSession",
  },
  Auth: {
    userCreate: process.env.NEXT_PUBLIC_DOMAIN + "/api/userCreate",
    userCreateForce:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/userCreateForce",
    userLogin: process.env.NEXT_PUBLIC_DOMAIN + "/api/userLogin",
    userLogout: process.env.NEXT_PUBLIC_DOMAIN + "/api/userLogout",
    userChangePasswordInitiate:
      process.env.NEXT_PUBLIC_DOMAIN + "/api/userChangePasswordInitiate",
  },
  Status: {
    Success: "ok",
    Unknown: "unknown",

    LoginInvalidPassword: "invalid_password", //login/password mismatch
    LoginUserNotActivated: "user_not_active", //user registered, but not activated using special link sent to email
    LoginInvalid2FACode: "2fa_invalid", //invalid totp code

    CreateUserLoginFormatInvalid: "login_format_invalid",
    CreateUserPasswordFormatInvalid: "password_format_invalid",
    CreateUserEmailFormatInvalid: "email_format_invalid",
    CreateUserNameFormatInvalid: "name_format_invalid",
    CreateUserDuplicateEmail: "duplicate_email", //already have another user with requested email
    CreateUserDuplicateLogin: "duplicate_login", //already have user with requested login
    CreateUserSmtpError: "smtp_client_create_error", //internal error with SMTP protocol client
    CreateUserEmailSendError: "email_send_error", //error received from SMTP server, details in pool log
    CreateUserFeePlanNotAllowed: "fee_plan_not_allowed", //setup fee plan available only from admin account
    CreateUserFeePlanNotExists: "fee_plan_not_exists", //non-existent fee plan sent

    ActionUnknownId: "unknown_id", //invalid or already activated id
    ActionUnknownLogin: "unknown_login", //internal error?
    ActionInvalidPasswordFormat: "password_format_invalid", //password does not meet requirements
    ActionInvalid2Fa: "2fa_invalid", //invalid totp code
    Action2FaAlreadyActivated: "2fa_already_activated", //double 2fa activation
    Action2FaNotActivated: "2fa_not_activated", //double 2fa deactivation
    ActionUserAlreadyActivated: "user_already_active", //internal error?
    ActionUnknownType: "unknown_type", //internal error?,

    SettingsInvalidAddress: "invalid_address",

    PayoutError: "payout_error",
    InsufficientBalance: "insufficient_balance",
    NoBalance: "no_balance",
  },
};
